import { ApiChatRequest, ApiFeedbackItemRequest, ApiSubmitIssueRequest, GenericHttpResult } from '@agunity/api-v4';
import { apiService } from '../../api/apiService';

export const startChatModal =
  () =>
    async (
    ) => {
      const response = await apiService.chatV10StartCreate();
      return response;
    };

export const postChatModalMsg =
  (data: ApiChatRequest) =>
    async (
    ) => {
      const response = await apiService.chatV10PostCreate(data);
      return response;
    };

export const closeChatModal =
  () =>
    async (
    ) => {
      const response = await apiService.chatV10StopCreate();
      return response;
    };

export const closeFeedbackModal =
  () =>
    async (
    ) => {
      const response = await apiService.uiV10NoFeedbackCreate();
      return response;
    };

export const submitFeedback =
  (data: ApiFeedbackItemRequest) =>
    async (
    ) => {
      const response = await apiService.uiV10FeedbackCreate(data);
      return response;
    };

export const submitIssue =
  (data: ApiSubmitIssueRequest) =>
    async (
    ) => {
      const response = await apiService.uiV10RaiseIssueCreate(data);
      return response;
    };
    
export const getFindPersonById = (data: ApiSubmitIssueRequest) => {
  return async (): Promise<GenericHttpResult<void>> => {
    const response = await apiService.uiV10RaiseIssueCreate(data);
    return response;
  };
};
    